import React from 'react'
import { components } from 'react-select'
import Tooltip from '@material-ui/core/Tooltip'
import { ChevronDown, X } from 'lucide-react'
import { tokens, primitives } from '../assets/tokens'

// Indicadores de react-select con los mismos iconos de lucide que los Select y Autocomplete del
// tema (chevron de 18 y X de 16), para que todos los desplegables se vean iguales
const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <ChevronDown size={18} color={primitives.neutral[800]} />
  </components.DropdownIndicator>
)

const ClearIndicator = props => (
  <components.ClearIndicator {...props}>
    <X size={16} color={tokens.color.text.tertiary} />
  </components.ClearIndicator>
)

// Contenedor de valores de un multi-select que solo pinta los primeros `max` chips y agrupa el resto en
// una pastilla «+N» con tooltip, para que el campo no crezca en altura con muchos valores (filtros aplicados)
export const limitedValueContainer = (max = 2) => {
  const LimitedValueContainer = ({ children, ...props }) => {
    const [chips, ...rest] = Array.isArray(children) ? children : [children]
    if (!Array.isArray(chips) || chips.length <= max) {
      return <components.ValueContainer {...props}>{children}</components.ValueContainer>
    }
    const hiddenLabels = props.getValue().slice(max).map(option => option.label)
    return (
      <components.ValueContainer {...props}>
        {chips.slice(0, max)}
        <Tooltip
          arrow
          title={<div>{hiddenLabels.map(label => <div key={label}>{label}</div>)}</div>}
        >
          <span className="select-more-values">+{hiddenLabels.length}</span>
        </Tooltip>
        {rest}
      </components.ValueContainer>
    )
  }
  return LimitedValueContainer
}

export const veloraSelectComponents = {
  DropdownIndicator,
  ClearIndicator,
  IndicatorSeparator: null
}

export default veloraSelectComponents
